// Utilitário para gerenciar progresso dos cursos usando localStorage
class CourseProgressManager {
  constructor() {
    this.storagePrefix = 'course_progress_';
  }

  // Obter chave do localStorage para um curso
  getStorageKey(courseId) {
    return `${this.storagePrefix}${courseId}`;
  }

  // Carregar progresso de um curso
  loadProgress(courseId) {
    try {
      const storageKey = this.getStorageKey(courseId);
      const stored = localStorage.getItem(storageKey);
      
      if (stored) {
        const progress = JSON.parse(stored);
        return Array.isArray(progress) ? progress : [];
      }
    } catch (error) {
      console.error('Erro ao carregar progresso:', error);
    }
    
    return [];
  }

  // Salvar progresso de um curso
  saveProgress(courseId, completedModules) {
    try {
      const storageKey = this.getStorageKey(courseId);
      const modulesArray = Array.isArray(completedModules) 
        ? completedModules 
        : Array.from(completedModules);
      
      localStorage.setItem(storageKey, JSON.stringify(modulesArray));
      
      // Disparar evento customizado para sincronização entre componentes
      window.dispatchEvent(new CustomEvent('courseProgressUpdated', {
        detail: { courseId, completedModules: modulesArray }
      }));
      
      return true;
    } catch (error) {
      console.error('Erro ao salvar progresso:', error);
      return false;
    }
  }

  // Verificar se um módulo específico está completo
  isModuleCompleted(courseId, moduleId) {
    const completedModules = this.loadProgress(courseId);
    return completedModules.includes(parseInt(moduleId));
  }

  // Marcar módulo como completo
  markModuleAsCompleted(courseId, moduleId) {
    const completedModules = this.loadProgress(courseId);
    const moduleIdInt = parseInt(moduleId);
    
    if (!completedModules.includes(moduleIdInt)) {
      completedModules.push(moduleIdInt);
      return this.saveProgress(courseId, completedModules);
    }
    
    return true; // Já estava completo
  }

  // Obter lista de módulos completos
  getCompletedModules(courseId) {
    return this.loadProgress(courseId);
  }

  // Calcular progresso percentual
  calculateProgress(courseId, totalModules) {
    if (!totalModules || totalModules === 0) return 0;
    
    const completedModules = this.loadProgress(courseId);
    return Math.round((completedModules.length / totalModules) * 100);
  }

  // Limpar progresso de um curso
  clearProgress(courseId) {
    try {
      const storageKey = this.getStorageKey(courseId);
      localStorage.removeItem(storageKey);
      
      window.dispatchEvent(new CustomEvent('courseProgressUpdated', {
        detail: { courseId, completedModules: [] }
      }));
      
      return true;
    } catch (error) {
      console.error('Erro ao limpar progresso:', error);
      return false;
    }
  }
}

// Exportar instância singleton
const courseProgress = new CourseProgressManager();
export default courseProgress;
